import { environment } from 'src/environments/environment'

export const apiEndpointUrl = (isMock: boolean = false) => {
	return !isMock ? environment.api.url : environment.api.mockUrl || environment.api.url
}

export const apiAuthEndpointUrl = (isMock: boolean = false) => {
	return !isMock ? environment.apiAuth.url : environment.apiAuth.mockUrl || environment.apiAuth.url
}
